import { t } from "i18next";
import { ClientTypeTag } from "../../../../modules/client/components/tags/ClientTypeTag";
import { ClientType } from "../../../../modules/client/enums";
import {
  AgentHistoryItem,
  BooleanHistoryItem,
  DateHistoryItem,
  EmptyHistoryItem,
  NoteHistoryItem,
} from "./commonHistoryItems";

const TypeItem = (value: ClientType) => <ClientTypeTag type={value} />;

const IdentityCardTypeHistoryItem = (value?: string) => {
  if (!value) {
    return <EmptyHistoryItem />;
  }

  return <span>{t(`client.enums.clientIdentityCardType.${value}`)}</span>;
};

export const ClientHistoryItemsMap = new Map<string, (value: any) => React.JSX.Element>([
  ["managedBy", AgentHistoryItem],
  ["birthDate", DateHistoryItem],
  ["note", NoteHistoryItem],
  ["type", TypeItem],
  ["lastContractDate", DateHistoryItem],
  ["identityCardType", IdentityCardTypeHistoryItem],
  ["verifiedByOcr", BooleanHistoryItem],
  ["verifiedByBiometry", BooleanHistoryItem],
  ["sanctioned", BooleanHistoryItem],
  ["involvedInCrime", BooleanHistoryItem],
  ["pep", BooleanHistoryItem],
]);
